import StudioEditor from '@grapesjs/studio-sdk/react';
import { tableComponent, listPagesComponent, fsLightboxComponent, lightGalleryComponent, swiperComponent, iconifyComponent, accordionComponent, flexComponent, rteTinyMce, canvasEmptyState, canvasFullSize, canvasGridMode, layoutSidebarButtons, youtubeAssetProvider } from '@grapesjs/studio-sdk-plugins';
import '@grapesjs/studio-sdk/style';

export default function App() {
  return (
    <StudioEditor
      style={{
        height: '100vh',
        width: '100vw'
      }}
      options={{
        licenseKey: 'DEMO_LOCALHOST_KEY',
        // licenseKey: '83ed4666e0f4493cbd5107190c7d68e343972986d4a742cd8eb3bfd02193e045',
      theme: 'light',
      customTheme: {
        default: {
          colors: {
            global: {
              background1: "rgba(40, 45, 40, 1)",
              background2: "rgba(30, 35, 30, 1)",
              background3: "rgba(20, 25, 20, 1)",
              backgroundHover: "rgba(50, 55, 50, 1)",
              text: "rgba(210, 220, 210, 1)",
              border: "rgba(70, 80, 70, 1)",
              focus: "rgba(100, 180, 140, 0.8)",
              placeholder: "rgba(140, 150, 140, 1)"
            },
            primary: {
              background1: "rgba(80, 160, 100, 1)",
              background3: "rgba(50, 120, 80, 1)",
              backgroundHover: "rgba(70, 140, 90, 1)",
              text: "rgba(255, 255, 255, 1)"
            },
            component: {
              background1: "rgba(60, 80, 70, 1)",
              background2: "rgba(50, 70, 60, 1)",
              background3: "rgba(40, 60, 50, 1)",
              text: "rgba(210, 220, 210, 1)"
            },
            selector: {
              background1: "rgba(70, 130, 90, 1)",
              background2: "rgba(90, 150, 110, 1)",
              text: "rgba(255, 255, 255, 1)"
            },
            symbol: {
              background1: "rgba(90, 160, 110, 1)",
              background2: "rgba(70, 140, 90, 1)",
              background3: "rgba(50, 120, 80, 1)",
              text: "rgba(255, 255, 255, 1)"
            }
          }
        }
      },
      project: {
        type: 'web'
      },
      assets: {
        storageType: 'self',
        // Provide a custom upload handler for assets
        onUpload: async ({ files }) => {
          const body = new FormData();
          for (const file of files) {
            body.append('files', file);
          }
          const response = await fetch('ASSETS_UPLOAD_URL', { method: 'POST', body });
          const result = await response.json();
          // The expected result should be an array of assets, eg.
          // [{ src: 'ASSET_URL' }]
          return result;
        },
        // Provide a custom handler for deleting assets
        onDelete: async ({ assets }) => {
          const body = JSON.stringify(assets);
          await fetch('ASSETS_DELETE_URL', { method: 'DELETE', body });
        }
      },
      storage: {
        type: 'self',
        // Provide a custom handler for saving the project data.
        onSave: async ({ project }) => {
          // throw new Error('Implement your "onSave"!');
          const body = new FormData();
          body.append('project', JSON.stringify(project));
          await fetch('PROJECT_SAVE_URL', { method: 'POST', body });
        },
        // Provide a custom handler for loading project data.
        onLoad: async () => {
          // throw new Error('Implement your "onLoad"!');
          const response = await fetch('PROJECT_LOAD_URL');
          const project = await response.json();
          // The project JSON is expected to be returned inside an object.
          return { project };
        },
        autosaveChanges: 100,
        autosaveIntervalMs: 10000
      },
      plugins: [
        tableComponent.init({ /* Plugin options: https://app.grapesjs.com/docs-sdk/plugins/components/table */ }),
        listPagesComponent.init({ /* Plugin options: https://app.grapesjs.com/docs-sdk/plugins/components/listPages */ }),
        fsLightboxComponent.init({ /* Plugin options: https://app.grapesjs.com/docs-sdk/plugins/components/fslightbox */ }),
        lightGalleryComponent.init({ /* Plugin options: https://app.grapesjs.com/docs-sdk/plugins/components/lightGallery */ }),
        swiperComponent.init({ /* Plugin options: https://app.grapesjs.com/docs-sdk/plugins/components/swiper */ }),
        iconifyComponent.init({ /* Plugin options: https://app.grapesjs.com/docs-sdk/plugins/components/iconify */ }),
        accordionComponent.init({ /* Plugin options: https://app.grapesjs.com/docs-sdk/plugins/components/accordion */ }),
        flexComponent.init({ /* Plugin options: https://app.grapesjs.com/docs-sdk/plugins/components/flex */ }),
        rteTinyMce.init({ /* Plugin options: https://app.grapesjs.com/docs-sdk/plugins/rte/tinymce */ }),
        canvasEmptyState.init({ /* Plugin options: https://app.grapesjs.com/docs-sdk/plugins/canvas/emptyState */ }),
        canvasFullSize.init({ /* Plugin options: https://app.grapesjs.com/docs-sdk/plugins/canvas/full-size */ }),
        canvasGridMode.init({ /* Plugin options: https://app.grapesjs.com/docs-sdk/plugins/canvas/grid-mode */ }),
        layoutSidebarButtons.init({ /* Plugin options: https://app.grapesjs.com/docs-sdk/plugins/layout/sidebar-buttons */ }),
        youtubeAssetProvider.init({ /* Plugin options: https://app.grapesjs.com/docs-sdk/plugins/asset-providers/youtube-asset-provider */ })
      ]
      }}
    />
  );
}